import { render, staticRenderFns } from "./Special.vue?vue&type=template&id=b7bfa7c0&scoped=true"
import script from "./Special.vue?vue&type=script&lang=js"
export * from "./Special.vue?vue&type=script&lang=js"
import style0 from "./Special.vue?vue&type=style&index=0&id=b7bfa7c0&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b7bfa7c0",
  null
  
)

export default component.exports